var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _rect3, _path0, _g, _path1, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _polyline, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _text, _g3, _path34, _path35, _path36, _path37, _path38, _polyline2, _line, _line2, _line3, _line4, _circle, _polygon, _circle2, _circle3, _circle4, _circle5, _line5, _path39, _path40, _path41, _path42, _path43, _line6, _rect4, _rect5, _path44, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPodcastplanningproductiontab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-14,.cls-17,.cls-19,.cls-22,.cls-23,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-31,.cls-32,.cls-33,.cls-34,.cls-4{fill:none;}.cls-2{fill:#d8c4df;}.cls-20,.cls-3{fill:#2f2143;}.cls-4{stroke:#364e54;}.cls-14,.cls-17,.cls-19,.cls-22,.cls-23,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-31,.cls-32,.cls-33,.cls-34,.cls-4{stroke-miterlimit:10;}.cls-17,.cls-4{stroke-width:0.8px;}.cls-5{fill:#21525e;}.cls-6{fill:#364e54;}.cls-7{fill:#544741;}.cls-8{clip-path:url(#clip-path);}.cls-9{fill:#c7b299;}.cls-10{clip-path:url(#clip-path-2);}.cls-11{fill:#5e443c;}.cls-12{fill:#fabba2;}.cls-13{fill:#9a499c;}.cls-14{stroke:#ffc20e;stroke-width:0.2px;}.cls-15{fill:#192f34;}.cls-16{fill:#fff;}.cls-17{stroke:#544741;}.cls-18{fill:#ffc20e;}.cls-19{stroke:#002f3e;stroke-width:2.4px;}.cls-20{font-size:35px;font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-21{opacity:0.6;}.cls-22,.cls-27,.cls-28,.cls-29,.cls-31,.cls-32,.cls-33,.cls-34{stroke:#662d91;}.cls-22{stroke-width:0.62px;}.cls-23,.cls-26{stroke:#2f2143;}.cls-23{stroke-width:0.86px;}.cls-24{fill:#2e1f42;}.cls-25{stroke:#2e1f42;stroke-width:1.29px;}.cls-26{stroke-width:0.87px;}.cls-27,.cls-32{stroke-width:0.32px;}.cls-28{stroke-width:0.88px;}.cls-29{stroke-width:0.65px;}.cls-30{fill:#386994;}.cls-31{stroke-width:0.37px;}.cls-32,.cls-33{stroke-linecap:round;}.cls-33{stroke-width:0.28px;}.cls-34{stroke-width:0.66px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.87,250.23a22.11,22.11,0,0,0-1.19,11.13,16.22,16.22,0,0,0,7.17.76,13.18,13.18,0,0,1,9.93,4.42,12,12,0,0,1,2.75,6.65H85.16l3.34-23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.84,248.13a22.37,22.37,0,0,0,4,4.73,16.65,16.65,0,0,0,1.82-.84,17.38,17.38,0,0,0,4.16-3.19,13.19,13.19,0,0,1,10.45-3,12,12,0,0,1,6.38,3.32l-26.31,22.13-12.22-19.73,9.47-8a21.91,21.91,0,0,0,2.21,4.55"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "podcast planning &amp;amp; production tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 765,
    height: 277
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M199.82,277h42.93a7.62,7.62,0,0,0-7.62-7.62h-27.7A7.62,7.62,0,0,0,199.82,277Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179,128.14s13.67,2.82,12.54,16.05c0,0-2.68,22.43,12.21,15.29,0,0,7.71-4.93,10.64-4.18,0,0,8.43,2.82,6.71,7.79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.8,129.44l-2.3-.82a1.73,1.73,0,0,1,1.16-3.27l2.3.82a1.73,1.73,0,0,1-1.16,3.27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.66,126.42l17,4.33a1.94,1.94,0,0,0,1.46,0,1.87,1.87,0,0,0,.87-1c.5-1,1.43-3.27,2.54-6.24a1.81,1.81,0,0,0-.17-1.47,2.09,2.09,0,0,0-1.43-.9l-15.53-7.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.19,126.78,161,113.6l-7.14-2.7a7.06,7.06,0,0,0-7.42,3.3,7.75,7.75,0,0,0-.38,6.32,7.05,7.05,0,0,0,2.1,2.8l8.08,3.46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.93,155.56h-3.28V126.29a1.56,1.56,0,0,1,1.56-1.56h.16a1.56,1.56,0,0,1,1.56,1.56Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.9,126.78a.61.61,0,0,1-.61.61.61.61,0,0,1-.62-.61.62.62,0,0,1,.62-.62.61.61,0,0,1,.61.62"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 162.62,
    y: 155.27,
    width: 11.33,
    height: 3.73
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.77,115.08a.76.76,0,1,1-.76-.75.75.75,0,0,1,.76.75"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157,113.38a.76.76,0,0,1-1.51,0,.76.76,0,0,1,1.51,0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 216.9,
    y: 165.07,
    width: 8.11,
    height: 104.15
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M119.53,273.19H85.16l3.34-23h12.37a22.11,22.11,0,0,0-1.19,11.13,16.22,16.22,0,0,0,7.17.76,13.18,13.18,0,0,1,9.93,4.42,12,12,0,0,1,2.75,6.65"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "85.62 270.01 107.81 270.01 113.08 263.65 124.69 263.65 122.08 274.08 82.95 275.01 85.62 270.01"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.53,272.49h0a2.81,2.81,0,0,0,3.33-2.17L51.3,206.91a2.81,2.81,0,0,0-5.5-1.17L32.36,269.16a2.81,2.81,0,0,0,2.17,3.33"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.19,274.22h0A2.83,2.83,0,0,0,62,271.41V206.58a2.81,2.81,0,0,0-5.62,0v64.83a2.82,2.82,0,0,0,2.81,2.81"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.89,273.14h0a2.82,2.82,0,0,0,2.21-3.3L72.58,206.23a2.81,2.81,0,0,0-5.52,1.09l12.53,63.6a2.82,2.82,0,0,0,3.3,2.22"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M164.69,249.14l-26.31,22.13-12.22-19.73,9.47-8a21.91,21.91,0,0,0,2.21,4.55,22.37,22.37,0,0,0,4,4.73,16.65,16.65,0,0,0,1.82-.84,17.38,17.38,0,0,0,4.16-3.19,13.19,13.19,0,0,1,10.45-3,12,12,0,0,1,6.38,3.32"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "136.69 268.53 153.67 254.25 153.61 246 162.49 238.52 167.21 248.18 137.87 274.08 136.69 268.53"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M76.34,207.57H40.59a3.21,3.21,0,0,1,0-6.41H76.34a3.21,3.21,0,1,1,0,6.41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.54,201.82l27.2,17.47,21.46,38.36,21.23-14.35s-15.27-29.84-30.88-40.07Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.28,255.6l33.81,1.82,2.45-52.75a20.21,20.21,0,0,0-2.88-10.94c-3.28-5.37-8.41-7.39-11-8.39-1.67-.65-3.89-1.31-15.89-2-4.44-.25-8.13-.38-10.72-.45l-39.74-1.74s-3.69,19.68,17.21,20.89l35.2,3.62Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M68.74,110.49s-.46-5.86.62-9c0,0,11.68,2.36,11.51-9.92,0,0,2.62-1.71,2.43-3.87,0,0-3.89-1.06-4-7.18,0,0,.91-6.09-2.33-9.78,0,0-31.7-17.77-21.88,37.41Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.49,117.53l-4,20s12.88,12.66,17,15c0,0,1.9,1.61,6,1.12l34.85-5.51-.83-11.52-31.77,4.7Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M115.54,110.16s2.49-1.86,3-3c0,0,2.06-2.57-2.07-.77,0,0-3.28.94-5.69,8.23l-4.25,5.68,7.77,4s2.32-4.17,3.5-4.35c0,0,6.14,1.15,7.25,1.29a4.41,4.41,0,0,0,2.76-.7s2.34-1.25,1.72-2c0,0-.17-.57-1.37,0a3.49,3.49,0,0,1-3.58-.09,6.31,6.31,0,0,0,3.53-.54s2.55-1.3,2-3.3c0,0,2.13-1.7,1.79-2.58,0,0-.22-.92-2.88.77a7.08,7.08,0,0,1-2.19,1l-3.34-.81a11.14,11.14,0,0,0,2.87-.57c.81-.41,4.28-2.39,4.3-3.56,0,0-.1-1.31-2.77.2a12.85,12.85,0,0,1-2.74,1.35Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M35.57,181.84l40,1.76s5.78-55.2,3.28-61.24c0,0-.41-4.88-6.32-10.88l-19.81-6.26s-10.07,6.39-12.07,23.09l-8.3,45.31s-.83,6.6,3.2,8.22"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M126.8,145.53l4-1.61s7.73,2.72,10.72-.86c0,0,.77-.94-5.51-1a12.55,12.55,0,0,1,7.73-3.56,9.4,9.4,0,0,1,2.66,1.07s2.94.91,1.23-1.21c0,0-2.59-2.65-4.84-2.4s-15.44,3-15.44,3l-.19,0Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.23,140l-21-21.15A9.38,9.38,0,0,0,59,117.19a9.63,9.63,0,0,0-7.23,2.31c-2.78,2.68-3.39,7.37-1.27,11.43,0,0,13.27,15.15,25.29,20.32,0,0,10,5.83,17.8.92,0,0,12.48-6,23.09-29.17l-10.33-5s-20.59,22.63-22.12,22"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M47.69,182.37s-9.59,17.45,52.72,17.33l-6.67,50.89"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M83,250.23c.47-.12,26.26,1.76,26.26,1.76"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M68.67,82.87c-1.16-5.45-.21-7.71,1-8.75,3.31-2.81,10.71,1.71,13.13-1.23a4.15,4.15,0,0,0,.56-3.3c.89-.1,3.52-.46,3.72-1.56.1-.55-.45-1.07-.66-1.27-12-11.53-24.86-6-24.86-6a20.69,20.69,0,0,0-9.39,9.08,3.28,3.28,0,0,0-2.68-.52C46.07,70.36,44.51,80,47.91,87a17.81,17.81,0,0,0,6,6.83s-2.53-9.42,2.23-13.45c2.8-2.37,6.46-1.85,7.41-1.71"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M72.66,92.68l5.77.41s-.4,4.64-2.89,4.09c0,0-2.57-.4-2.88-4.5"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "77.01 82.56 75.37 82.56 76.74 83.77"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M63.19,80.15s3.19-17.14,9-19.67c0,0-3-3.8-6.84-1,0,0-4.22,5.34-6.83,20.68Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M67.52,85.43a7.39,7.39,0,1,1-7.39-7.38,7.39,7.39,0,0,1,7.39,7.38"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M64.73,85.43a4.6,4.6,0,1,1-4.6-4.6,4.6,4.6,0,0,1,4.6,4.6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M77.33,251.28c0,2.29-8.22,4.15-18.37,4.15s-18.36-1.86-18.36-4.15,8.22-4.14,18.36-4.14S77.33,249,77.33,251.28Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.05,167.34H89.25a4.1,4.1,0,0,1,0-8.19h134.8a4.1,4.1,0,0,1,0,8.19"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152.56,113.19a.75.75,0,0,1-1.5,0,.75.75,0,1,1,1.5,0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.85,113.19a.76.76,0,1,1-.75-.76.76.76,0,0,1,.75.76"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.75,114.89a.75.75,0,0,1-1.5,0,.75.75,0,1,1,1.5,0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(225.45 124.33)"
  }, "PODCAST PLANNING", /*#__PURE__*/React.createElement("tspan", {
    x: 45.13,
    y: 38
  }, "&amp; PRODUCTION"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 374.82,
    y: 39.89,
    width: 3.39,
    height: 44.54,
    rx: 1.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 383.3,
    y: 50.14,
    width: 3.39,
    height: 34.29,
    rx: 1.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M393,84.44h0a1.7,1.7,0,0,1-1.7-1.7V22.29a1.7,1.7,0,1,1,3.39,0V82.74A1.7,1.7,0,0,1,393,84.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 399.28,
    y: 65.59,
    width: 3.39,
    height: 18.84,
    rx: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 407.28,
    y: 56.68,
    width: 3.39,
    height: 27.75,
    rx: 1.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 415.27,
    y: 45.9,
    width: 3.39,
    height: 38.53,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 423.26,
    y: 64.67,
    width: 3.39,
    height: 19.76,
    rx: 1.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 431.25,
    y: 46.75,
    width: 3.39,
    height: 37.68,
    rx: 1.48
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M174.18,62c5.56,1,7.84-.1,8.86-1.36a34.3,34.3,0,0,0,2.66-5.42c.74-1.66,1.13-2.67,1.76-2.69s1.2,1.15,1.88,2.52c2,4.17,3.46,7,5,7.15,1,.09,2-1.24,4-3.92,2.72-3.65,3.18-5.57,4.22-5.5s1.17,1.89,3.21,5.36c1.4,2.37,2.94,5,4.35,4.81.88-.12,1.06-1.23,3.13-4.93,2.2-3.95,2.76-4.07,3-4,.77.12,1.24,1.85,1.93,4.43.48,1.76.58,2.79,1.51,3.51a3.38,3.38,0,0,0,1.86.64c3.76.36,10,.56,10.58.57"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M665.08,70.86a3.68,3.68,0,1,1-3.68-3.68,3.67,3.67,0,0,1,3.68,3.68"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M678.83,70.86a3.68,3.68,0,1,1-3.68-3.68,3.67,3.67,0,0,1,3.68,3.68"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M692.18,70.86a3.68,3.68,0,1,1-3.68-3.68,3.67,3.67,0,0,1,3.68,3.68"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M692,59.93H657.39a8.8,8.8,0,0,0-8.78,8.78V73a8.8,8.8,0,0,0,8.78,8.78h23.05a13.47,13.47,0,0,1,6.69,2.16A14.24,14.24,0,0,1,693,93.29a21.36,21.36,0,0,0,1.54-4.94c.49-2.74.14-4.13,1.28-5.63.91-1.18,1.72-1.11,2.76-2,1.23-1.06,2.41-3.16,2.11-7.72V68.71A8.8,8.8,0,0,0,692,59.93Z"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "411.33 251.92 411.33 264.14 446.56 264.14 446.56 213.96 411.33 213.96 411.33 229.8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 415.03,
    y1: 231.28,
    x2: 433.35,
    y2: 231.28
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 420.05,
    y1: 237.59,
    x2: 440.79,
    y2: 237.59
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 415.81,
    y1: 250.48,
    x2: 442.08,
    y2: 250.48
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 420.25,
    y1: 244.03,
    x2: 440.59,
    y2: 244.03
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 409.69,
    cy: 241.12,
    r: 11.11
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "415.05 241.91 406.92 237.22 406.92 246.61 415.05 241.91"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 637.07,
    cy: 219.45,
    r: 24.49
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 637.07,
    cy: 219.45,
    r: 34.28
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 637.07,
    cy: 219.45,
    r: 24.49
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 637.07,
    cy: 219.45,
    r: 44.63
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 686.21,
    y1: 220.17,
    x2: 722.57,
    y2: 220.17
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M722.45,222.61a2.44,2.44,0,1,0-2.44-2.44,2.43,2.43,0,0,0,2.44,2.44"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M586.37,220.17H550"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M550.13,217.74a2.44,2.44,0,1,0,2.43,2.43,2.43,2.43,0,0,0-2.43-2.43"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M638.09,231.81h0a8.21,8.21,0,0,1-8.19-8.19v-9.79a8.19,8.19,0,1,1,16.38,0v9.79a8.21,8.21,0,0,1-8.19,8.19"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M646.28,223.62a8.19,8.19,0,1,1-16.38,0"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-30",
    x1: 638.09,
    y1: 205.64,
    x2: 638.09,
    y2: 205.64
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 627.58,
    y: 208.47,
    width: 21.02,
    height: 26.17,
    rx: 9.28
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 637.86,
    y: 231.64,
    width: 0.95,
    height: 6.65
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M642.12,239.3h-7.59a.62.62,0,1,1,0-1.23h7.59a.62.62,0,1,1,0,1.23"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 629.9,
    y1: 214.16,
    x2: 634.13,
    y2: 214.16
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 629.9,
    y1: 215.68,
    x2: 635.45,
    y2: 215.68
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 629.9,
    y1: 217.2,
    x2: 633.81,
    y2: 217.2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 646.28,
    y1: 214.32,
    x2: 642.06,
    y2: 214.32
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 646.28,
    y1: 215.84,
    x2: 640.73,
    y2: 215.84
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 646.28,
    y1: 217.36,
    x2: 642.38,
    y2: 217.36
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 636.34,
    y1: 205.72,
    x2: 636.34,
    y2: 209.94
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 637.86,
    y1: 205.72,
    x2: 637.86,
    y2: 211.27
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 639.38,
    y1: 205.72,
    x2: 639.38,
    y2: 209.62
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 627.58,
    y1: 223.62,
    x2: 648.61,
    y2: 223.62
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 269.61,
    cy: 231.28,
    r: 8.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcastplanningproductiontab);
export default __webpack_public_path__ + "static/media/podcast planning & production tab.881072de13956dcf58a1342223fa3bd6.svg";
export { ForwardRef as ReactComponent };